import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { __Trm } from "request/configuration/__Trm";

/**
 * Hook para obtener TRM (getTrm)
 * Tiene un staleTime más corto porque el TRM puede cambiar más frecuentemente
 * Cachea los datos para evitar peticiones duplicadas
 * 
 * @param {boolean} enabled - Si la query debe ejecutarse (default: true)
 * @returns {Object} Objeto con data, isLoading, error, etc. de React Query
 */
export const useTrm = (enabled = true) => {
  const token = useSelector((state) => state.auth.dataUser.token);

  return useQuery({
    queryKey: ["trm"],
    queryFn: async () => {
      const res = await __Trm(token);
      return res?.data?.status?.data || null;
    },
    enabled: enabled && !!token,
    staleTime: 1000 * 60 * 5, // 5 minutos para TRM (más corto porque puede cambiar más frecuentemente)
    gcTime: 1000 * 60 * 15, // 15 minutos en caché
    refetchOnMount: false, // No refetch al montar si los datos están frescos
    refetchOnWindowFocus: false, // No refetch al cambiar de ventana
    retry: 1, // Solo reintentar una vez en caso de error
  });
};
